<template>
  <div class="algorithmSeting">
    <a-card>
      <a-form-model layout="inline">
        <a-form-model-item label="名称">
          <a-input placeholder="请输入" allow-clear :maxLength="20" v-model="search.name" @keyup.enter="getList(1)" />
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="getList(1)">查询</a-button>
          <a-button style="margin: 0 35px 0 15px" @click="resetSearch()">重置</a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="add()" icon="plus" v-permission="'Content.AlgorithmSeting.Add'">添加</a-button>
        </a-form-model-item>
      </a-form-model>
      <div class="table">
        <a-table
          style="min-width: 800px"
          :columns="columns"
          row-key="id"
          :pagination="tableRelevant.tablePagination"
          :loading="tableRelevant.tableLoading"
          :locale="tableRelevant.locale"
          :dataSource="tableRelevant.tableDataSource"
        >
          <div slot="seting" slot-scope="text">
            {{ text.str }}
          </div>
          <div slot="action" slot-scope="text">
            <a @click="toDetails(text)" style="margin-right: 8px" v-permission="'Content.AlgorithmSeting.Edit'">编辑</a>
            <a-popconfirm v-permission="'Content.AlgorithmSeting.Delete'" title="确认要删除此算法配置吗？" @confirm="deleteSet(text.id)" ok-text="确认" cancel-text="取消">
              <a style="color: #f5222d">
                <a-icon type="delete" />
                删除</a
              >
            </a-popconfirm>
          </div>
        </a-table>
      </div>
      <!-- 编辑添加 -->
      <a-modal v-model="algorithmRelevant.visible" :title="algorithmRelevant.title" destroyOnClose @cancel="handleCancel" @ok="modleOk" width="800px">
        <a-form-model ref="ruleForm" :model="algorithmRelevant.data" :rules="rules" labelAlign="right" :label-col="{ span: 10 }" :wrapper-col="{ span: 12 }">
          <a-form-model-item ref="name" class="aName" label="算法名称" prop="name" :wrapper-col="{ span: 17, offset: 0 }" :label-col="{ span: 5 }">
            <a-input v-model="algorithmRelevant.data.name" />
          </a-form-model-item>
          <a-form-model-item label="性别匹配" required :wrapper-col="{ span: 17, offset: 0 }" :label-col="{ span: 5 }">
            <a-switch v-model="algorithmRelevant.data.applicableGender" />
          </a-form-model-item>
          <div class="query">
            <div class="letf">
              <a-form-model-item ref="a1" label="能力权重(a1)" prop="a1">
                <a-input-number v-model="algorithmRelevant.data.a1" :min="-1" :max="1" :precision="2" />
              </a-form-model-item>
              <a-form-model-item ref="a3" label="累计跳过次数(a3)" prop="a3">
                <a-input-number v-model="algorithmRelevant.data.a3" :min="-1" :max="1" :precision="2" />
              </a-form-model-item>
              <a-form-model-item ref="a5" label="上次跳过时差(a5)" prop="a5" class="flex">
                <a-input-number v-model="algorithmRelevant.data.a5" :min="-1" :max="1" :precision="2" />
              </a-form-model-item>
              <a-form-model-item ref="a7" label="通过比例(a7)" prop="a7">
                <a-input-number v-model="algorithmRelevant.data.a7" :min="-1" :max="1" :precision="2" />
              </a-form-model-item>
              <a-form-model-item ref="a9" label="age(a9)" prop="a9" class="flex">
                <a-input-number v-model="algorithmRelevant.data.a9" :min="-1" :max="1" :precision="2" />
              </a-form-model-item>
            </div>
            <div class="right">
              <a-form-model-item ref="a2" label="累计完成次数(a2)" prop="a2">
                <a-input-number v-model="algorithmRelevant.data.a2" :min="-1" :max="1" :precision="2" />
              </a-form-model-item>
              <a-form-model-item ref="a4" label="上次完成时差(a4)" prop="a4" class="flex">
                <a-input-number v-model="algorithmRelevant.data.a4" :min="-1" :max="1" :precision="2" />
              </a-form-model-item>
              <a-form-model-item ref="a6" label="最近是否通关(a6)" prop="a6" class="flex">
                <a-input-number v-model="algorithmRelevant.data.a6" :min="-1" :max="1" :precision="2" />
              </a-form-model-item>
              <a-form-model-item ref="a8" label="水平(a8)" prop="a8">
                <a-input-number v-model="algorithmRelevant.data.a8" :min="-1" :max="1" :precision="2" />
              </a-form-model-item>
              <a-form-model-item ref="a10" label="sex(a10)" prop="a10">
                <a-input-number v-model="algorithmRelevant.data.a10" :min="-1" :max="1" :precision="2" />
              </a-form-model-item>
            </div>
          </div>
          <div class="progress-bonus">
            <a-form-model-item required label="连续课时惩罚"  class="flex" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
              <a-row class="recentCount">
                <span>连续课时数：</span>
                <a-form-model-item   prop="recentCount" class="flex">
                  <a-input-number class="input" v-model="algorithmRelevant.data.recentCount" :min="0" :max="999" :precision="0" />
                </a-form-model-item>
                <span>惩罚系数：</span>
                <a-form-model-item prop="diversityPenalty" class="flex">
                  <a-input-number class="input" v-model="algorithmRelevant.data.diversityPenalty" :min="0" :max="1" :precision="2" />
                </a-form-model-item>
              </a-row>
            </a-form-model-item>
            <a-form-model-item required label="进阶加分" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
              <a-row class="progress-bonus-row" v-for="(item, index) in algorithmRelevant.data.progressBonus" :key="item.rid">
                <span>关卡 ≥</span>
                <a-form-model-item :rules="[{ required: true, message: '请填写内容', trigger: 'blur' }]" :prop="`progressBonus[${index}].stage`" class="flex">
                  <a-input-number class="input" v-model="item.stage" :min="0" :max="999" :precision="0" />
                </a-form-model-item>
                <span>且通关率 ></span>
                <a-form-model-item :rules="[{ required: true, message: '请填写内容', trigger: 'blur' }]" :prop="`progressBonus[${index}].correctness`" class="flex">
                  <a-input-number class="input" v-model="item.correctness" :min="0" :max="100" :precision="2" />
                </a-form-model-item>
                <span>%，+</span>
                <a-form-model-item :rules="[{ required: true, message: '请填写内容', trigger: 'blur' }]" :prop="`progressBonus[${index}].progressBonus`" class="flex">
                  <a-input-number class="input" v-model="item.progressBonus" :min="0" :max="1" :precision="2" />
                </a-form-model-item>
                <div class="icons">
                  <a-icon v-if="index + 1 == algorithmRelevant.data.progressBonus.length" style="margin-right: 8px" type="plus-circle" @click="addProgressBonus" />
                  <a-icon v-if="algorithmRelevant.data.progressBonus.length > 1" @click="removeProgressBonus(item.rid)" type="minus-circle" />
                </div>
              </a-row>
            </a-form-model-item>
          </div>
        </a-form-model>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
const columns = [
  { title: '名称', dataIndex: 'name' },
  { title: '配置方案', scopedSlots: { customRender: 'seting' }, align: 'center' },
  { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 120 },
]
export default {
  name: 'algorithmSeting',
  data() {
    return {
      columns,
      // 搜索表单
      search: {
        name: '', //游戏名称
      },
      //表格相关
      tableRelevant: tableRelevant.call(this),
      //添加编辑学生相关
      algorithmRelevant: {
        title: '添加算法',
        loading: false,
        visible: false,
        data: {
          name: '',
          applicableGender: false,
          a1: '',
          rndMin: '',
          rndMax: '',
          a2: '',
          a3: '',
          a4: '',
          a5: '',
          a6: '',
          a7: '',
          a8: '',
          a9: '',
          a10: '',
          a11: '',
          progressBonus: [{ rid: +new Date() }],
          recentCount: '',
          diversityPenalty: '',
        },
      },
      currentId: '',
    }
  },
  computed: {
    rules() {
      return {
        name: { required: true, message: '请填写算法名称', trigger: 'blur' },
        a1: { required: true, message: '请填写a1', trigger: 'blur' },
        a2: { required: true, message: '请填写a2', trigger: 'blur' },
        a3: { required: true, message: '请填写a3', trigger: 'blur' },
        a4: { required: true, message: '请填写a4', trigger: 'blur' },
        a5: { required: true, message: '请填写a5', trigger: 'blur' },
        a6: { required: true, message: '请填写a6', trigger: 'blur' },
        a7: { required: true, message: '请填写a7', trigger: 'blur' },
        a8: { required: true, message: '请填写a8', trigger: 'blur' },
        a9: { required: true, message: '请填写a9', trigger: 'blur' },
        a10: { required: true, message: '请填写a10', trigger: 'blur' },
        recentCount: { required: true, message: '请填写课时数', trigger: 'blur' },
        diversityPenalty: { required: true, message: '请填写惩罚系数', trigger: 'blur' },
      }
    },
  },
  created() {
    this.getList(1)
  },
  methods: {
    addProgressBonus() {
      this.algorithmRelevant.data.progressBonus.push({ rid: +new Date() })
    },
    removeProgressBonus(rid) {
      this.algorithmRelevant.data.progressBonus = this.algorithmRelevant.data.progressBonus.filter((v) => v.rid != rid)
    },
    handleCancel() {
      this.$refs.ruleForm.resetFields()
    },
    getList(pageIndex) {
      let params = {
        name: this.search.name,
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
      }
      this.algorithmRelevant.loading = true
      this.$message.destroy()
      this.$http.algorithm
        .pagelist(params)
        .then((res) => {
            res.data.items.forEach((v) => {
              let str = ''
              for (let key in v.coefficients) {
                const val = v.coefficients[key]
                if (val === null) continue
                if (Array.isArray(val) && val.length == 0) continue
                if (typeof val == 'object') {
                  str += JSON.stringify(val)
                } else {
                  str += '' + key + '=' + val + ';'
                }
                v.str = str
              }
            })
            this.tableRelevant.tableDataSource = res.data.items
            this.tableRelevant.tablePagination.total = res.data.totalCount
            this.tableRelevant.tablePagination.current = res.data.pageIndex
        })
        .finally(() => {
          this.algorithmRelevant.loading = false
        })
    },
    toDetails(text) {
      let params = {
        id: text.id,
      }
      this.currentId = text.id
      this.$http.algorithm
        .detail(params)
        .then((res) => {
            const data = res.data
            for (let key in data.coefficients) {
              if (key == 'diversityPenalty') {
                this.algorithmRelevant.data['diversityPenalty'] = data.coefficients['diversityPenalty']?.diversityPenalty
                this.algorithmRelevant.data['recentCount'] = data.coefficients['diversityPenalty']?.recentCount
              } else if (key == 'progressBonus') {
                if (!data.coefficients['progressBonus']?.length) {
                  this.algorithmRelevant.data['progressBonus'] = [{ rid: +new Date() }]
                } else {
                  this.algorithmRelevant.data['progressBonus'] = data.coefficients['progressBonus'].map((v, i) => ({ rid: +new Date() + i, ...v }))
                }
              } else {
                this.algorithmRelevant.data[key] = data.coefficients[key]
              }
            }
            this.algorithmRelevant.data.name = data.name
            this.algorithmRelevant.title = '编辑算法'
            this.algorithmRelevant.visible = true

        })
        .finally(() => {
          this.algorithmRelevant.loading = false
        })
    },
    add() {
      this.algorithmRelevant.title = '添加算法'
      this.algorithmRelevant.visible = true
      this.algorithmRelevant.data = {
        name: '',
        applicableGender: false,
        a1: '',
        a2: '',
        a3: '',
        a4: '',
        a5: '',
        a6: '',
        a7: '',
        a8: '',
        a9: '',
        a10: '',
        progressBonus: [{ rid: +new Date() }],
        recentCount: '',
        diversityPenalty: '',
      }
    },
    modleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const params = {}
          const coefficients = JSON.parse(JSON.stringify(this.algorithmRelevant.data))
          coefficients.diversityPenalty = {
            diversityPenalty: coefficients.diversityPenalty,
            recentCount: coefficients.recentCount,
          }
          delete coefficients.recentCount
          coefficients.progressBonus = coefficients.progressBonus.map((v) => (delete v.rid, { ...v }))
          if (this.algorithmRelevant.title == '编辑算法') {
            params.id = this.currentId
          }
          params.coefficients = coefficients
          params.name = coefficients.name
          this.$message.destroy()
          this.$http.algorithm
            .edit(params)
            .then((res) => {
                this.$message.success('操作成功')
                this.algorithmRelevant.visible = false
                this.getList(1)
            })
            .catch((err) => {})
        } else {
        }
      })
    },
    deleteSet(id) {
      const formData = new FormData()
      formData.append('id', id)
      this.$http.algorithm
        .delete(formData)
        .then((res) => {
            this.$message.success(res.message)
            this.getList(1)
        })
        .catch((err) => {})
    },
    resetSearch() {
      this.search.name = ''
      this.getList(1)
    },
  },
}
</script>

<style lang="less" scoped>
.table {
  margin-top: 25px;
}
.aName {
  width: 101%;
}
.rnd {
  display: flex;
  // width: 42%;
  position: relative;
  .rndMax {
    position: absolute;
    right: -85px;
    /deep/ .ant-form-explain {
      margin-left: 14px;
      font-size: 12px;
    }
  }
}
.query {
  display: flex;
  justify-content: space-around;
}
.flex {
  /deep/ .ant-form-item-children {
    display: flex;
    align-items: center;
    .symbol {
      margin-right: 5px;
    }
  }
}

/deep/ .ant-input-number {
  width: 100%;
}
.progress-bonus {
  ::v-deep .ant-form-item {
    margin-bottom: 0;
  }
  .input {
    width: 80px;
  }
  .progress-bonus-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .icons {
    font-size: 20px;
    cursor: pointer;
  }
}
.acenter {
  align-items: center;
}
.recentCount{
    display: flex;
    span{
        margin: 0 8px;
    }
}
</style>
